import React from 'react';
import { useIntl } from 'react-intl';
import { requiredVideoEmbedInput } from '../../../core/formValidation';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';

export const TaskVideoEmbed = ({ fields, name }: { fields?: any; name?: string }) => {
  const intl = useIntl();
  const rhf = useFormContext?.();
  const rhfArray = name && rhf?.control ? useFieldArray({ name, control: rhf.control }) : null;

  const api =
    fields ||
    (rhfArray && {
      map: (fn: (itemName: string, index: number) => any) =>
        rhfArray.fields.map((_, index) => fn(`${name}.${index}`, index)),
      remove: (index: number) => rhfArray.remove(index),
      push: (item?: any) => rhfArray.append(item ?? ''),
    });

  if (!api) {
    return null;
  }
  const videoForm = () => {
    return (
      <div style={{ marginTop: '1rem' }}>
        {api.map((item: any, index: number) => (
          <div key={index}>
            <div>
              <div>
                <div
                  className="form-group padded"
                  style={{ display: 'flex', justifyContent: 'space-between', gap: '4px' }}
                >
                  <span style={{ width: '100%' }}>
                    <Controller
                      name={`${item}`}
                      render={({ field }) =>
                        requiredVideoEmbedInput({
                          input: field,
                          className: 'form-control',
                          placeholder: intl.formatMessage({ id: 'videoSupport' }),
                          onBlur: (e: any) => e?.preventDefault?.(),
                        })
                      }
                    />
                  </span>
                  <button
                    type="button"
                    className={'close multi-form-delete'}
                    onClick={(e) => {
                      e.preventDefault();
                      api.remove(index);
                    }}
                  >
                    <i className="icon icon-squared-cross" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="inline-add-item-button">
      <button
        type="button"
        className={'button'}
        onClick={(e) => {
          e.preventDefault();
          api.push();
        }}
      >
        {intl.formatMessage({ id: 'addVideo' })}
      </button>
      {api ? videoForm() : <div />}
    </div>
  );
};
